import { render, staticRenderFns } from "./UpdatePersonalForm.vue?vue&type=template&id=06017701"
import script from "./UpdatePersonalForm.vue?vue&type=script&lang=ts"
export * from "./UpdatePersonalForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports